
import { IBarighet } from "./IBarighet";

export class Barighet implements IBarighet {
    key: number;
    value: string;
    aktiv: boolean;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static A = "A";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static B = "B";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static C = "C";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static D = "D";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static Alla = [
        Barighet.A,
        Barighet.B,
        Barighet.C,
        Barighet.D
    ];

    constructor(key: number, value: string) {
        this.key = key;
        this.value = value;
        this.aktiv = false;
    }

}
